import React, { useRef, useEffect, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from "react-router-dom";
import * as PR from "../../prime-modules/index";
import { useTranslation } from "react-i18next";
import BundlesList from "../../components/EsimBundles";
import HeaderMenu from "../../components/layout/HeaderMenu";
import "../home/Home.scss";
import { useDispatch, useSelector } from "react-redux";
import { scrollToBundlesActions } from "../../store/scrollToBundles";
import { ScrollTo } from "../../utils/ScrollTo";
import { useToast } from "../../context/ToastContext";
import { messageCatalogActions } from "../../store/messageCatalog";
import { getAssetsData } from "../../services/api";
import getAssets from "../../assets/data/brandingAssets.json"
import { generateSlug } from "../../utils/reuse";

const Home = () => {
  const { i18n } = useTranslation();
  const { labels, home, general, isBase64Image, faqNew } = useToast()
  const dispatch = useDispatch();
  const scrollToBundlesState = useSelector(state => state.scrollToBundles.scrollToBundlesState);
  const ref = useRef(null);
  const [faq, setFaq] = useState([]);

  const [loading, setLoading] = useState(true);

  const handleClick = () => {
    ScrollTo(ref, -20);
  };

  useEffect(() => {
    if (scrollToBundlesState) {
      handleClick();
      dispatch(scrollToBundlesActions.desleteSrollToBundles());
    }

    // const defaultLang = i18n.language.split("-")[0];
    // const faqData = {
    //   en: faq_en,
    //   es: faq_es,
    //   pt: faq_pt,
    //   fr: faq_fr,
    //   de: faq_de,
    // };

    //  if (faqData[defaultLang]) {
    //   setFaq(faqData[defaultLang]);
    // }
  }, [scrollToBundlesState, dispatch]);

  useEffect(() => {
  const faqsNew = faqNew?.["faq-new"];
  if (faqNew || faqsNew) {
    setLoading(false);
  }
  if (!faqsNew) return;
  const categoriesData = faqsNew?.categories ? JSON.parse(faqsNew.categories) : {};
  const filteredCategories = Object.keys(categoriesData)
    .filter((key) => categoriesData[key].status !== 0)
    .reduce((acc, key) => {
      acc[key] = categoriesData[key];
      return acc;
    }, {});

  const filteredFaqData = Object.keys(filteredCategories)?.map((acc) => {
    return faqsNew[acc] && JSON.parse(faqsNew[acc])
  }).flat();

 setFaq(filteredFaqData);
}, [faqNew]);

  useEffect(() => {
    const getResponse = (response) => {
      if (response.result === "SUCCESS") {
        dispatch(messageCatalogActions.storeHome(response.data))
      }
    }
    getAssetsData(i18n.language, 'home', getResponse)
  }, [i18n.language, dispatch])

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{general.GEN0009}</title>
        <meta property="og:description" content={general.GEN0010} />
      </Helmet>

      {/* Header Section */}
      <section className="header-section">
        <div className="header">
          <header>
            <HeaderMenu />
          </header>
          <div className="fixed-height"></div>
        </div>
        <div className="grid header-text">
          <div className="col-12 lg:col-5 md:col-5">
            <div className="header-text-box">
              <h1>{home.HOME0002}</h1>
              <p>{home.HOME0003}</p>
              <PR.Button
                label={home.HOME0004}
                className="goto-plans-button p-button-rounded"
                onClick={handleClick}
              />
            </div>
          </div>
          <div className="col-12 lg:col-7 md:col-7">
            <PR.Image
              className="banner-img"
              src={isBase64Image(home.HOME0001) ? `data:image/png;base64,${home.HOME0001}` : getAssets.home.header_banner}
              alt="No Ban Aid needed"
            />
          </div>
        </div>
      </section>

      {/* Options Section */}
      <section className="options-section">
        <div className="grid">
          <div className="col-12 lg:col-4 md:col-4">
            <div className="option-box">
              <PR.Image src={isBase64Image(home.HOME0007) ? `data:image/png;base64,${home.HOME0007}` : getAssets.home.instant_activation} alt="Instant Activation" />
              <h2>{home.HOME0005}</h2>
              <p>{home.HOME0006}</p>
            </div>
          </div>
          <div className="col-12 lg:col-4 md:col-4">
            <div className="option-box">
              <PR.Image src={isBase64Image(home.HOME0010) ? `data:image/png;base64,${home.HOME0010}` : getAssets.home.attractive_rates} alt="Attractive Rates" />
              <h2>{home.HOME0008}</h2>
              <p>{home.HOME0009}</p>
            </div>
          </div>
          <div className="col-12 lg:col-4 md:col-4">
            <div className="option-box">
              <PR.Image src={isBase64Image(home.HOME0013) ? `data:image/png;base64,${home.HOME0013}` : getAssets.home.global_coverage} alt="Global Coverage" />
              <h2>{home.HOME0011}</h2>
              <p>{home.HOME0012}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Offer Section */}
      <section className="offer-section">
        <div className="grid column-reverse">
          <div className="col-12 lg:col-6 md:col-6 p-0 text-center">
            <PR.Image
              className="hand-iphone-img"
              src={isBase64Image(home.HOME0014) ? `data:image/png;base64,${home.HOME0014}` : getAssets.home.hand_iphone}
              alt="Connectivity"
            />
          </div>
          <div className="col-12 lg:col-6 md:col-6 p-0">
            <div className="option-box">
              <h2>{home.HOME0015}</h2>
              <p>{home.HOME0016}</p>
              <PR.Button label={home.HOME0017} className="choose-plans-button p-button-rounded" onClick={handleClick} />
            </div>
          </div>
        </div>
      </section>

      {/* Plans Section */}
      <section className="plan-section" ref={ref}>
        <div className="grid align-items-center">
          <h2>{labels.LBL0296}</h2>
        </div>
        <div className="card">
          <div className="bundles-section">
            <BundlesList />
          </div>
        </div>
      </section>

      <div className="download-app-section">
          <div className="container">
            <div className="grid align-items-center">
              <div className="col-12 md:col-6">
                <div className="custom-padding">
                    <h2>{home.HOME0038 || "Get the App Today!"}</h2>
                    <p>{home.HOME0039 || "Discover a powerful, secure, and flexible mobile data solution built for travellers. Download our app and connect effortlessly worldwide."}</p>
                    <a href={home.HOME0043 || "https://apps.apple.com/in/app/esimlinks/id6742406495"} target="_blank" rel="noreferrer">
                      <PR.Image
                        className="app-icon"
                        src={isBase64Image(home.HOME0040) ? `data:image/png;base64,${home.HOME0040}` : getAssets.home.app_store}
                        alt="Apple Store"
                      />
                    </a>
                    <a href={home.HOME0044 || "https://play.google.com/store/apps/details?id=com.esimlinks.innovative&hl=en_IN"} target="_blank" rel="noreferrer">
                      <PR.Image
                        className="app-icon"
                        src={isBase64Image(home.HOME0041) ? `data:image/png;base64,${home.HOME0041}` : getAssets.home.google_play_store}
                        alt="Google Play"
                      />
                    </a>
                </div>
              </div>
              <div className="col-12 md:col-6 text-center p-0">
                <PR.Image
                  className="app-screen"
                  src={isBase64Image(home.HOME0042) ? `data:image/png;base64,${home.HOME0042}` : getAssets.home.app_screen}
                  alt="Benefits"
                />
              </div>
            </div>
          </div>
      </div>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="grid">
          <div className="col-12 text-center md:mb-7">
            <h2>{labels.LBL0139}</h2>
          </div>
          <div className="col-12 lg:col-6 md:col-6 text-center">
            <div className="option-box">
              <PR.Image
                className="benefits-img"
                src={isBase64Image(home.HOME0033) ? `data:image/png;base64,${home.HOME0033}` : getAssets.home.benefits_image}
                alt="Benefits"
              />
            </div>
          </div>
          <div className="col-12 lg:col-6 md:col-6">
            <div className="option-box">
              <div className="flex align-items-center gap-4 mb-5">
                <div className="benefits-icon">
                  <PR.Image
                    className="hand-iphone-img"
                    src={isBase64Image(home.HOME0020) ? `data:image/png;base64,${home.HOME0020}` : getAssets.home.best_pricing_plans}
                    alt="Multi-Network Connectivity"
                  />
                </div>
                <div className="benefits-text">
                  <h3>{home.HOME0018}</h3>
                  <p>{home.HOME0019}</p>
                </div>
              </div>

              <div className="flex align-items-center gap-4 mb-5">
                <div className="benefits-icon">
                  <PR.Image
                    className="hand-iphone-img"
                    src={isBase64Image(home.HOME0023) ? `data:image/png;base64,${home.HOME0023}` : getAssets.home.easy_installation}
                    alt="Fast Connections"
                  />
                </div>
                <div className="benefits-text">
                  <h3>{home.HOME0021}</h3>
                  <p>{home.HOME0022}</p>
                </div>
              </div>

              <div className="flex align-items-center gap-4 mb-5">
                <div className="benefits-icon">
                  <PR.Image
                    className="hand-iphone-img"
                    src={isBase64Image(home.HOME0026) ? `data:image/png;base64,${home.HOME0026}` : getAssets.home.multi_network_connectivity}
                    alt="Support 24/7"
                  />
                </div>
                <div className="benefits-text">
                  <h3>{home.HOME0024}</h3>
                  <p>{home.HOME0025}</p>
                </div>
              </div>

              <div className="flex align-items-center gap-4 mb-5">
                <div className="benefits-icon">
                  <PR.Image
                    className="hand-iphone-img"
                    src={isBase64Image(home.HOME0029) ? `data:image/png;base64,${home.HOME0029}` : getAssets.home.fast_connections}
                    alt="Easy Installation"
                  />
                </div>
                <div className="benefits-text">
                  <h3>{home.HOME0027}</h3>
                  <p>{home.HOME0028}</p>
                </div>
              </div>

              <div className="flex align-items-center gap-4">
                <div className="benefits-icon">
                  <PR.Image
                    className="hand-iphone-img"
                    src={isBase64Image(home.HOME0032) ? `data:image/png;base64,${home.HOME0032}` : getAssets.home.support_24_7}
                    alt="Best Pricing Plans"
                  />
                </div>
                <div className="benefits-text">
                  <h3>{home.HOME0030}</h3>
                  <p>{home.HOME0031}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="grid align-items-center">
          <div className="col-12 lg:col-10 md:col-10 md:col-offset-1 lg:col-offset-1">
            <h2>{labels.LBL0136}</h2>
            {loading ? 
  [...Array(4)].map((_, index) => (
    <div key={index} className="flex items-center justify-between p-3 border rounded-lg shadow-sm">
      <PR.Skeleton width="100%" height="60px" />
      {/* <PR.Skeleton shape="circle" size="30px" /> */}
    </div>
  ))
: faq && faq.length > 0 && <PR.Accordion className="mt-5">
                  {faq.slice(0, 4).map((qa, j) => (qa.question &&
                      <PR.AccordionTab header={qa.question} key={j} id={generateSlug(qa.question)}>
                      <div dangerouslySetInnerHTML={{ __html: qa.answer }} />
                    </PR.AccordionTab>
                  ))}
                </PR.Accordion>
              }
            {/* {faq &&
              faq.length > 0 &&
              faq.slice(0, 1).map((item, i) => (
                <PR.Accordion key={i}>
                  {item.QA.slice(0, 4).map((qa, j) => (
                    <PR.AccordionTab header={qa.question} key={j}>
                      {qa.answer.map((an, h) => (
                        <div key={h}>
                          {an.content_heading && (
                            <p><strong>{an.content_heading}</strong></p>
                          )}
                          {an.content && (
                            <p>{an.content}</p>
                          )}
                          {an.olist?.length > 0 && (
                            <ol>
                              {an.olist.map((anl, nh) => (
                                <li key={nh}>{anl}</li>
                              ))}
                            </ol>
                          )}
                          {an.ulist?.length > 0 && (
                            <ul>
                              {an.ulist.map((anl, nh) => (
                                <li key={nh}>{anl}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </PR.AccordionTab>
                  ))}
                </PR.Accordion>
              ))} */}
          </div>
        </div>
        <div className="text-center faq-custom-margin">
          <Link to="/faq" className="view-all-button">{labels.LBL0324}</Link>
        </div>
      </section>
    </HelmetProvider>
  );
};

export default Home;